import { LuBed, LuBox, LuCar, LuEllipsis, LuUtensils } from 'react-icons/lu';

/** Icon and colour of each expense type (the stored `type` values). */
export const EXPENSE_TYPE_STYLES = {
  transportation: { icon: LuCar, tone: 'tw-bg-blue-500/10 tw-text-blue-700 tw-ring-blue-500/25 dark:tw-text-blue-300' },
  accommodation: { icon: LuBed, tone: 'tw-bg-emerald-500/10 tw-text-emerald-700 tw-ring-emerald-500/25 dark:tw-text-emerald-300' },
  meal: { icon: LuUtensils, tone: 'tw-bg-amber-500/10 tw-text-amber-700 tw-ring-amber-500/25 dark:tw-text-amber-300' },
  supplies: { icon: LuBox, tone: 'tw-bg-violet-500/10 tw-text-violet-700 tw-ring-violet-500/25 dark:tw-text-violet-300' },
  other: { icon: LuEllipsis, tone: 'tw-bg-slate-500/10 tw-text-slate-600 tw-ring-slate-500/20 dark:tw-text-slate-300' },
};
